export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = 4